module.exports = __webpack_public_path__ + "static/media/TC.22d0021e.svg";